"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPagination = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var renderPagination = function (page, pageTotal, onChangePage, t, currentUrl, getPagedUrlCallback) {
    var onGotoPrevPage = function (e) {
        e.preventDefault();
        onChangePage(page - 1);
        return false;
    };
    var onGotoNextPage = function (e) {
        e.preventDefault();
        onChangePage(page + 1);
        return false;
    };
    var getPagedUrlCallbackDefault = function (url, n) {
        var pcs = url.split('/').map(function (it) { return it.indexOf('page-') > -1 ? "page-" + n : it; });
        if (pcs[pcs.length - 1] === '')
            pcs.pop();
        return pcs.concat(url.indexOf('page-') === -1 ? ["page-" + n] : []).join('/');
    };
    var getPagedUrl = getPagedUrlCallback ? getPagedUrlCallback : getPagedUrlCallbackDefault;
    var renderPrevPage = function () {
        if (page === 1)
            return '';
        var extraAttr = {};
        if (currentUrl) {
            extraAttr.href = getPagedUrl(currentUrl, page - 1);
            return (React.createElement("a", __assign({ onClick: onGotoPrevPage, className: "c-pagination__item" }, extraAttr),
                React.createElement("span", null, t.prev)));
        }
        return (React.createElement("div", { onClick: onGotoPrevPage, className: "c-pagination__item" },
            React.createElement("span", null, t.prev)));
    };
    var renderNextPage = function () {
        if (page === pageTotal)
            return '';
        var extraAttr = {};
        if (currentUrl) {
            extraAttr.href = getPagedUrl(currentUrl, page + 1);
            return (React.createElement("a", __assign({ onClick: onGotoNextPage, className: "c-pagination__item" }, extraAttr),
                React.createElement("span", null, t.next)));
        }
        return (React.createElement("div", { onClick: onGotoNextPage, className: "c-pagination__item" },
            React.createElement("span", null, t.next)));
    };
    var renderPage = function (i, current) {
        var goToPage = function (e) {
            e.preventDefault();
            onChangePage(i + 1);
            return false;
        };
        var classes = classnames_1.default([
            "c-pagination__item",
            {
                "c-pagination__item--current": i === current,
            },
        ]);
        if (i === current) {
            return (React.createElement("span", { key: i, className: classes }, i + 1));
        }
        var extraAttr = {};
        if (currentUrl) {
            extraAttr.href = getPagedUrl(currentUrl, i + 1);
            return (React.createElement("a", __assign({ key: i, onClick: goToPage, className: "c-pagination__item" }, extraAttr),
                React.createElement("span", null, i + 1)));
        }
        return (React.createElement("div", { onClick: goToPage, className: "c-pagination__item" },
            React.createElement("span", null, i + 1)));
    };
    var renderPages = function (page, pageTotal) {
        var pages = [];
        for (var i = 0; i < pageTotal; i = i + 1) {
            pages.push(renderPage(i, page - 1));
        }
        pages = pages.slice(page - 1, page + 2 >= pageTotal ?
            pageTotal - 1 :
            page + 2);
        if (page > 2) {
            pages.unshift((React.createElement("span", { key: "pred", className: "c-pagination__item" }, "...")));
        }
        if (page !== 1) {
            pages.unshift(renderPage(0, -1));
        }
        if (page < pageTotal - 3) {
            pages.push((React.createElement("span", { key: "postd", className: "c-pagination__item" }, "...")));
        }
        if (page <= pageTotal) {
            pages.push(renderPage(pageTotal - 1, page - 1));
        }
        return pages;
    };
    return (React.createElement("div", { className: "c-pagination u-text-center" },
        renderPrevPage(),
        React.createElement("div", { className: "c-pagination__items" }, renderPages(page, pageTotal)),
        renderNextPage()));
};
exports.renderPagination = renderPagination;
